module.exports = "/_next/static/images/pg-d90dc677b6f14747295fc0b2a93ffdbd.png";